import { AvatarUserBuilder } from './avatar-user';
import { AvatarGroupBuilder } from './avatar-group';
import { AvatarCallCenterAgentStatus, AvatarAgentStatus } from '../types';
import { AvatarQueueBuilder } from './avatar-queue';
import { LabelDataBuilder } from './label-data';
import { CategoryBuilder } from './category';
import { flattenCategories } from '../../';
import { uuid } from '@wix/answers-lib';
// tslint:disable-next-line:max-line-length
var names = ['Bob', 'Jacob', 'Sima', 'Mazal', 'Uncle', 'Dod', 'Yasha', 'Yoshi', 'Daniel', 'Nimrod', 'Aaron', 'Gabi', 'Asaf', 'Boris', 'Tali', 'Adam', 'Itay', 'Elad', 'Zohar', 'Gil', 'Guy', 'Rami', 'Ramay', 'Bobby', 'John', 'Tal', 'Gal', 'Elliot', 'Shir', 'Ayelet', 'Michal', 'Eilon', 'Ben-el', 'Tavori', 'Joseph'];
export var randomId = function () { return uuid(); };
export var generateMany = function (gen, count) {
    return Array.apply(null, Array(count))
        .map(gen);
};
var enumToArray = function (en) {
    var arr = [];
    for (var i in en) {
        if (!isNaN(i) && en.hasOwnProperty(i)) {
            arr.push(parseInt(i, 10));
        }
    }
    return arr;
};
export var randomNumber = function (min, max) {
    if (min === void 0) { min = 0; }
    if (max === void 0) { max = 10; }
    return Math.floor((max - min) * Math.random() + min);
};
export var pickRandom = function (l, without) {
    if (without === void 0) { without = []; }
    var filteredList = l.filter((function (i) { return !without.includes(i); }));
    var idx = Math.floor(filteredList.length * Math.random());
    return filteredList[idx];
};
export var randomName = function () { return pickRandom(names) + randomNumber(1, 99); };
export var randomAvatarUser = function (isAgent) {
    if (isAgent === void 0) { isAgent = false; }
    return new AvatarUserBuilder()
        .withFirstName(randomName())
        .withLastName(randomName())
        .withIsAgent(isAgent)
        .build();
};
export var randomAvatarUsers = function (count, isAgent) {
    if (isAgent === void 0) { isAgent = false; }
    return generateMany(function () { return randomAvatarUser(isAgent); }, count);
};
export var randomAvatarGroup = function () { return new AvatarGroupBuilder()
    .withId(uuid())
    .withName(randomName())
    .build(); };
export var randomAvatarGroups = function (count) { return generateMany(randomAvatarGroup, count); };
export var randomCallCenterAgentStatus = function () {
    return pickRandom(enumToArray(AvatarCallCenterAgentStatus));
};
export var randomAgentStatus = function () {
    return pickRandom(enumToArray(AvatarAgentStatus));
};
export var randomAvatarQueue = function () { return new AvatarQueueBuilder()
    .withId(uuid())
    .withName(randomName())
    .build(); };
export var randomLabel = function () { return new LabelDataBuilder()
    .withId(uuid())
    .withName(randomName())
    .build(); };
export var randomLabels = function (count) { return generateMany(randomLabel, count); };
var randomCategory = function (children, locale) {
    if (children === void 0) { children = []; }
    if (locale === void 0) { locale = 'en'; }
    return new CategoryBuilder()
        .withId(uuid())
        .withLang(locale)
        .withName(randomName())
        .withChildren(children)
        .build();
};
// tslint:disable-next-line:max-line-length
export var randomFlatCategoryTree = function (howManyCategories, subsCatPerCategory, locale) {
    if (howManyCategories === void 0) { howManyCategories = 10; }
    if (subsCatPerCategory === void 0) { subsCatPerCategory = 0; }
    if (locale === void 0) { locale = 'en'; }
    var cats = generateMany(function () {
        var children = generateMany(function () { return randomCategory([], locale); }, subsCatPerCategory);
        return randomCategory(children, locale);
    }, howManyCategories);
    return flattenCategories(cats);
};
//# sourceMappingURL=random-builders.js.map